import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { State } from './types';

const initialState: State = {
  columnOrder: undefined,
};

export default createSlice({
  name: 'Restoration Hub',
  initialState,
  selectors: {
    selectColumnOrder: (state: State) => state.columnOrder,
  },
  reducers: {
    setColumnOrder: (
      state: State,
      action: PayloadAction<State['columnOrder']>,
    ) => {
      state.columnOrder = action.payload;
    },
  },
});
